import React from 'react';
import PropTypes from 'prop-types';
import {Dialogue, Button, Modal} from '@albert-io/atomic';
import {rejectInvite} from 'client/SchoolAdministration/School/ManageStaff/Staff/manageStaffUtils';

const DeleteInvitationModal = ({params, setStaffInviteToDelete, staffInviteToDelete}) => {
  return (
    <Modal handleClose={() => setStaffInviteToDelete(null)}>
      {({modalContentStyle}) => (
        <Dialogue
          className={modalContentStyle}
          inModal
          title='Delete Invitation'
          hideCloseBtn
          alignTitle='center'
        >
          <Dialogue.Body align='center'>
            <p>
              Are you sure you want to delete the invitation for
              <strong> {staffInviteToDelete.getEmail()}</strong>?
            </p>
          </Dialogue.Body>
          <Dialogue.BtnGroup align='right' className='u-display_inline'>
            <Button color='secondary' onClick={() => setStaffInviteToDelete(null)}>
              Cancel
            </Button>
            <Button
              color='destructive'
              onClick={() => {
                rejectInvite({
                  invite: staffInviteToDelete,
                  schoolId: params.schoolId
                });
                setStaffInviteToDelete(null);
              }}
            >
              Delete
            </Button>
          </Dialogue.BtnGroup>
        </Dialogue>
      )}
    </Modal>
  );
};

DeleteInvitationModal.propTypes = {
  setStaffInviteToDelete: PropTypes.func,
  params: PropTypes.object,
  staffInviteToDelete: PropTypes.object
};

export default DeleteInvitationModal;
